import React, { useState } from 'react'
import { getDesc, reframePlanetData } from '../function/function';


function PlanetDetails(props) {
    const planet = reframePlanetData(props.planet)

    // State:
    const [hoverDesc, setHoverDesc] = useState("")
    const [displayAttr, setDisplayAttr] = useState(null)

    const toggleDisplayAttr = (index) => {
        if (displayAttr === index) {
          setDisplayAttr(null); // Disable the currently active object
        } else {
          setDisplayAttr(index); // Enable the clicked object
        }
    };


  return (
    <div>
        <div className="planet_info_main_div">
            { Object.keys(planet).map(i => (
            <div>
                <div>
                    {typeof(planet[i]) === "string" && i==='name' && <p className="planet_main_desc">{planet[i]}</p>}
                </div>
                
                <div>
                    {Array.isArray(planet[i]) && (i !== "satellite" && i !== "manmade_satellite") && <p>{i}: {planet[i].map(arr => arr)}</p>}
                </div>

                <div>
                    {typeof(planet[i]) === 'object' && !Array.isArray(planet[i]) && 
                        <div>
                            <div className="planet_object_property_title" onClick={() => toggleDisplayAttr(i)}>
                                <p>{i}</p>
                                <p>{displayAttr === i ? "-" : "+"}</p>
                            </div>

                            {displayAttr === i && 
                                <div className="planet_object_property_scroll">
                            
                                    { Object.keys(planet[i]).map(attr => (
                                        <p className="planet_object_property_attr">
                                            <span onMouseEnter={() => setHoverDesc(getDesc(attr))}>{attr}:</span> {planet[i][attr]}
                                        
                                            <div className="planet_property_attr_hover">
                                                <p className="planet_property_attr_hover_desc">{hoverDesc}</p>
                                            </div>
                                        </p>
                                    ))}
                                </div>
                            }
                        </div>
                    }
                </div>


            </div>
        ))}

        </div>
    </div>
  )
}

export default PlanetDetails